module.exports = __webpack_public_path__ + "a8f7716b9f15a8e6a67b9e38121d76f0.jpg";